import { View, StyleSheet } from "react-native";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import Logo from "../../general/logos/Logo";
import CustomSpacing from "../../common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import UserInitial from "../../general/UserInitial/UserInitial";
import { LogoutIcon } from "../../svgIcons";
import TopMenuItem from "../TopMenuItem/TopMenuItem.web";
import SparkleWhite from "../../svgs/common/SparkleWhite";
import Sparkle from "../../svgs/common/Sparkle";
import { NotificationIcon } from "../../general/NotificationIcon/NotificationIcon";

function TopMenu({
  menuItems,
  selectedItem,
  logo,
  miniLogo,
  showMiniLogo,
  userInitial,
  isLTI,
  onItemPress,
  onSettingsPress,
  onLogoutPress,
  onNotifcationsPress,
  onAskAxioPress,
  companionName,
}) {
  const { isXLarge, isMedium, hp } = useResponsiveScreen();
  const isExpanded = isXLarge || !isMedium;
  const isMobile = !isMedium;

  const logoutTitle = isMedium ? "Logout" : "LOGOUT";

  return (
    <View style={[styles.mainMenu, isMobile && styles.mainMenuMobile]}>
      <View style={[styles.menu, isMobile && styles.menuMobile]}>
        <View>
          {isMedium && (
            <>
              <View style={isXLarge ? styles.topContainer : {}}>
                {isXLarge ? (
                  <Logo uri={logo} height={40} />
                ) : showMiniLogo ? (
                  <Logo uri={miniLogo} height={40} width={50} />
                ) : (
                  <View style={{ width: 80, height: 40 }}></View>
                )}
              </View>
            </>
          )}
        </View>
        <CustomSpacing type="horizontal" size="m" />
        <View role="menu">
          <View style={isMobile ? styles.verticalContainerColumn : styles.verticalContainerRow}>
            {menuItems.map((item, index) => (
              <TopMenuItem key={index} item={item} isSelected={selectedItem === item.name} onPress={onItemPress} />
            ))}
          </View>
        </View>
      </View>
      <View style={[styles.bottomContainer, isMedium ? {} : { padding: 15 }, isMobile && styles.bottomContainerMobile]}>
        {isExpanded && isMedium && (
          <>
            <CustomButton
              onPress={onAskAxioPress}
              text={`Ask ${companionName}`}
              leftIcon={
                <SparkleWhite accessibilityRole="img" accessibilityLabel="Ask AI Assistant" alt="Ask AI Assistant" />
              }
              size="s"
              styleType="primary"
              style={[styles.desktopSettingsButtons, styles.settingsButtons]}
              textStyle={{ fontSize: 14, color: "#ffffff" }}
              aria-label={`Ask ${companionName}`}
              accessibilityLabel="Ask AI Assistant"
              accessibilityHint="Open AI assistant chat"
            />
            <CustomSpacing type="horizontal" size="s" />
            <CustomButton
              onPress={onNotifcationsPress}
              text={null}
              leftIcon={
                <NotificationIcon accessibilityRole="img" accessibilityLabel="Notifications" alt="Notifications" />
              }
              size="m"
              styleType="transparent"
              style={styles.desktopSettingsButtons}
              textStyle={{ fontSize: 14 }}
              aria-label="Notifications"
              accessibilityLabel="Notifications"
              accessibilityHint="Toggle notifications"
            />
            <CustomSpacing type="horizontal" size="s" />
          </>
        )}

        <CustomButton
          onPress={onSettingsPress}
          text={null}
          leftIcon={
            <UserInitial
              initial={userInitial}
              type={"menu"}
              accessibilityRole="img"
              accessibilityLabel="User menu"
              alt="User menu"
            />
          }
          size={isMedium ? "m" : "s"}
          styleType="transparent"
          style={[isMedium ? styles.desktopSettingsButtons : {}, styles.settingsButtons]}
          textStyle={isMedium ? [{ fontSize: 14 }] : [styles.menuButtonText, { fontSize: hp(1.7) }]}
          aria-label="Settings"
          accessibilityLabel="  Settings"
          accessibilityHint="Navigate to settings"
        />

        {!isLTI && !isMedium && (
          <>
            <CustomSpacing type="vertical" size="m" />
            <CustomButton
              onPress={onAskAxioPress}
              text={`Ask ${companionName}`}
              leftIcon={<Sparkle />}
              size="s"
              styleType="transparent"
              style={styles.settingsButtons}
              textStyle={[styles.menuButtonText, { fontSize: hp(1.7), textTransform: "uppercase" }]}
              aria-label={`Ask ${companionName}`}
              accessibilityLabel="Ask AI Assistant"
              accessibilityHint="Open AI assistant chat"
            />
            <CustomSpacing type="vertical" size="m" />
            <CustomButton
              onPress={onLogoutPress}
              text={isExpanded ? logoutTitle : null}
              leftIcon={<LogoutIcon accessibilityRole="img" accessibilityLabel="Logout" alt="Logout" />}
              size="s"
              styleType="transparent"
              style={styles.settingsButtons}
              textStyle={[styles.menuButtonText, { fontSize: hp(1.7) }]}
              aria-label="Logout"
              accessibilityLabel="Logout"
              accessibilityHint="Logout from the application"
            />
          </>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  mainMenu: {
    paddingHorizontal: 20,
    backgroundColor: "#ffffff",
    paddingVertical: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderColor: "#EAECF0",
    borderBottomWidth: 1,
  },
  mainMenuMobile: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  menu: {
    backgroundColor: "#ffffff",
    flexDirection: "row",
    alignItems: "center",
  },
  menuMobile: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  bottomContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  bottomContainerMobile: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  verticalContainerRow: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  verticalContainerColumn: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
  },
  topContainer: {
    paddingHorizontal: 6.39,
  },
});

export default TopMenu;
